import { useEffect } from 'react'

interface UseSwiperAutoplayProps {
  autoplay: boolean
  disableSwipe: boolean
  scrollToNext: () => void
  autoplaySpeed: number
}

export function useSwiperAutoplay({ autoplay, disableSwipe, scrollToNext, autoplaySpeed }: UseSwiperAutoplayProps) {
  useEffect(() => {
    let autoplayInterval: NodeJS.Timeout | undefined
    if (autoplay && !disableSwipe) {
      autoplayInterval = setInterval(() => {
        scrollToNext()
      }, autoplaySpeed)
    }
    return () => clearInterval(autoplayInterval)
  }, [autoplay, disableSwipe])
}
